export default {
  title: 'Hoe vind je {{name}}?',
  description: 'Je feedback is anoniem en helpt ons te verbeteren.',
  upload_google_review: {
    title: 'Beoordeel ons en word beloond',
  },
};
